import { TDeviceType } from "@cian/ui-kit";

export const combineDataLayerObject = (analytics: any, breadCrumbs: string[], deviceType: TDeviceType, journal_pagetype?: string, journal_rubrics?: string) => {
  const { user } = analytics;

  return {
    user: {
      abGroup: user && 'abGroup' in user ? Number(user.abGroup) : 100,
      email: user && user.email ? user.email : undefined,
      type: user && user.userType ? user.userType : 'not_authorized',
      userId: user && user.realtyUserId ? Number(user.realtyUserId) : undefined,
      cianUserId: user && user.userId ? Number(user.userId) : undefined,
    },
    page: {
      breadCrumbs,
      pageType: 'Magazine',
      siteType: deviceType === 'phone' ? 'mobile' : deviceType,
      extra: {
        journal_pagetype,
        journal_rubrics,
      },
    },
    partner: {
      CriteoEmail: user && user.criteoEmail,
      CriteoNewCustomer: user && user.criteoNewCustomer,
    },
  };
};
